import { Invitation, UseInvitationOptions } from "simplydo/interfaces";
import { useInvitation, useTokenInvitation } from "simplydo/react/hooks";
import { styled } from "simplydo/react/styled";
import { CardContent } from "simplydo/react/ui/card";

import util from "utils/utils";

import InvitationCardLayout from "./InvitationCardLayout";

const NoteText = styled.span`
  font-size: 14px;
  color: #718096;
  white-space: pre-wrap;
`;

const Card = styled.div`
  ${CardContent} {
    flex-grow: 0;
  }
`;

type InviteCardProps = { invitation: Invitation; cardView?: boolean };

const invitationHookOptions: UseInvitationOptions = {
  onAccept: ({ title, message, confirm, cancel }) => {
    util.confirm(title, message).then(confirm).catch(cancel);
  },
};

const InviteCard = ({ invitation, cardView = true }: InviteCardProps) => {
  const vm = useInvitation(invitation, invitationHookOptions);

  return (
    <Card>
      <InvitationCardLayout
        cardView={cardView}
        invitation={invitation}
        vm={vm}
      />
      {!invitation.acceptedBy && invitation.note ? (
        <NoteText>&quot;{invitation.note}&quot;</NoteText>
      ) : null}
    </Card>
  );
};

export const TokenInviteCard = ({ invitation }: { invitation: Invitation }) => {
  const vm = useTokenInvitation(invitation, invitationHookOptions);

  return (
    <Card>
      <InvitationCardLayout cardView={false} invitation={invitation} vm={vm} />
      {!invitation.acceptedBy && invitation.note ? (
        <NoteText>&quot;{invitation.note}&quot;</NoteText>
      ) : null}
    </Card>
  );
};

export default InviteCard;
